<template>
  <!-- ════ HOME PAGE HERO ════ -->
  <section v-if="effectiveHeroType === 'home'" id="hero">
    <div class="scene-light" aria-hidden="true"></div>
    <div class="section-inner">
      <div class="hero-inner">
        <div class="hero-content">
          <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/logo-lockup.png"
            alt="Kellogg's&reg; Cocoa Loops × Wonka" class="hero-logos reveal">
          <h1 class="hero-headline reveal d1">Enter the World<br>of Wonka.</h1>
          <p class="hero-body reveal d2">Purchase limited-edition <b>Kellogg's<sup>&reg;</sup> Cocoa Loops with Wonka Hat
              Marshmallows</b>, upload your <b>qualifying receipt</b> and unlock your chance to win extraordinary
            prizes, including the most magical prize of all: a getaway for two to <b>Netflix House Las Vegas.</b>
          </p>
          <div class="hero-btns reveal d3">
            <router-link to="/upload" class="btn-gold">Upload Your Receipt<svg class="btn-icon" width="15" height="15"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg></router-link>
            <a href="#grand-prize" class="btn-outline-light">Explore The Adventure</a>
          </div>
        </div>
      </div>
    </div>
    <!-- Wave A-bottom: low-left → high-right. Fill = GP purple. -->

  </section>

  <!-- ════ INTERIOR HERO ════ -->
  <section v-if="effectiveHeroType === 'interior'" class="int-hero int-hero--ty" data-screen-label="Register — Hero">
    <div class="int-hero-inner">
      <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/logo-lockup.png" alt="Kellogg's&reg; Cocoa Loops × Wonka" class="int-hero-lockup">
      <h1>The Adventure<br>Begins Here</h1>
      <p>Continue your journey through the extraordinary<br>world of Wonka.</p>
    </div>
  </section>
</template>

<script>
import { useRouter } from 'vue-router';
import { computed } from 'vue';

export default {
  name: 'Banner',
  props: {
    heroType: {
      type: String,
      default: null,
      validator: (value) => value === null || ['home', 'interior', 'none'].includes(value)
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    screenLabel: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const router = useRouter();

    // Determine hero type based on current route if not explicitly provided
    const effectiveHeroType = computed(() => {
      // If heroType is explicitly provided, use it
      if (props.heroType !== null) {
        return props.heroType;
      }

      // Otherwise, determine from current route
      const currentPath = router.currentRoute.value.path.toLowerCase();

      // Home page shows home hero
      if (currentPath === '/' || currentPath === '/home') {
        return 'home';
      }

      // Interior pages show interior hero (register, verify, upload, error, etc.)
      if (['/register', '/upload', '/error'].some(path => currentPath === path)) {
        return 'interior';
      }

      // Thanks, pre-program, post-program pages show no hero
      if (['/thanks', '/preprogram', '/postprogram'].some(path => currentPath.includes(path))) {
        return 'none';
      }

      // Default
      return 'none';
    });

    return {
      effectiveHeroType
    };
  }
};
</script>
